import { render, staticRenderFns } from "./names.vue?vue&type=template&id=4009c822"
import script from "./names.vue?vue&type=script&lang=js"
export * from "./names.vue?vue&type=script&lang=js"
import style0 from "./names.vue?vue&type=style&index=0&id=4009c822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports